import { CERTIFICATE_TYPES } from './constants';

export const DOWNLOAD_CERTIFICATES_SETUP = 'DOWNLOAD_CERTIFICATES_SETUP';

export function downloadCertificatesSetup() {
    return { type: DOWNLOAD_CERTIFICATES_SETUP };
}

export const DOWNLOAD_CERTIFICATES_REQUEST = 'DOWNLOAD_CERTIFICATES_REQUEST';
export const DOWNLOAD_CERTIFICATES_SUCCESS = 'DOWNLOAD_CERTIFICATES_SUCCESS';
export const DOWNLOAD_CERTIFICATES_FAILURE = 'DOWNLOAD_CERTIFICATES_FAILURE';

export function downloadCertificates(certificateType) {
    const newState = { type: DOWNLOAD_CERTIFICATES_REQUEST };
    if (CERTIFICATE_TYPES.indexOf(certificateType) !== -1) {
        newState.certificateType = certificateType;
    }
    return newState;
}

export const downloadCertificatesSuccess = (downloadUrl) => {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_CERTIFICATES_SUCCESS };
};

export function downloadCertificatesFailure() {
    return { type: DOWNLOAD_CERTIFICATES_FAILURE };
}

export const GET_CLASSROOM_GROUPS_REQUEST = 'GET_CLASSROOM_GROUPS_REQUEST';
export const GET_CLASSROOM_GROUPS_SUCCESS = 'GET_CLASSROOM_GROUPS_SUCCESS';
export const GET_CLASSROOM_GROUPS_FAILURE = 'GET_CLASSROOM_GROUPS_FAILURE';

export const getClassroomGroups = classroomId =>
    ({
        type: GET_CLASSROOM_GROUPS_REQUEST,
        classroomId
    });

export const getClassroomGroupsSuccess = ({ data }) =>
    ({
        type: GET_CLASSROOM_GROUPS_SUCCESS,
        data
    });

export const getClassroomGroupsFailure = () =>
    ({
        type: GET_CLASSROOM_GROUPS_FAILURE
    });


export const SET_TEACHER_ID = 'SET_TEACHER_ID';

export function setTeacherId(name, selectedTeacherId) {
    return { type: SET_TEACHER_ID, selectedTeacherId };
}

export const SET_CLASSROOM_ID = 'SET_CLASSROOM_ID';

export function setClassroomId(name, selectedClassroomId) {
    return { type: SET_CLASSROOM_ID, selectedClassroomId };
}

export const SET_GROUP_ID = 'SET_GROUP_ID';

export function setGroupId(name, selectedGroupId) {
    return { type: SET_GROUP_ID, selectedGroupId };
}

export const CLEAR_CLASSROOM_GROUPS = 'CLEAR_CLASSROOM_GROUPS';

export function clearClassroomGroups() {
    return { type: CLEAR_CLASSROOM_GROUPS };
}

export const GET_ACADEMIC_YEAR_REQUEST = 'GET_ACADEMIC_YEAR_REQUEST';
export const GET_ACADEMIC_YEAR_SUCCESS = 'GET_ACADEMIC_YEAR_SUCCESS';
export const GET_ACADEMIC_YEAR_FAILURE = 'GET_ACADEMIC_YEAR_FAILURE';

export function getAcademicYear() {
    return { type: GET_ACADEMIC_YEAR_REQUEST };
}

export function getAcademicYearSuccess({ data }) {
    return { type: GET_ACADEMIC_YEAR_SUCCESS, data };
}

export function getAcademicYearFailure() {
    return { type: GET_ACADEMIC_YEAR_FAILURE };
}

export const GET_CERTIFICATES_SUMMARY_REQUEST = 'GET_CERTIFICATES_SUMMARY_REQUEST';
export const GET_CERTIFICATES_SUMMARY_SUCCESS = 'GET_CERTIFICATES_SUMMARY_SUCCESS';
export const GET_CERTIFICATES_SUMMARY_FAILURE = 'GET_CERTIFICATES_SUMMARY_FAILURE';

export function getCertificatesSummary() {
    return { type: GET_CERTIFICATES_SUMMARY_REQUEST };
}

export function getCertificatesSummarySuccess({ data }) {
    return { type: GET_CERTIFICATES_SUMMARY_SUCCESS, data };
}

export function getCertificatesSummaryFailure() {
    return { type: GET_CERTIFICATES_SUMMARY_FAILURE };
}

export const ON_DATE_PICKER_CHANGE = 'ON_DATE_PICKER_CHANGE';

export function onDatePickerChange(dateType, startDate, endDate) {
    return { type: ON_DATE_PICKER_CHANGE, dateType, startDate, endDate };
}




// WEBPACK FOOTER //
// ./app/containers/download-certificates/actions.js